export default {
  methods: {
    redirectToLockersOrDeliveries() {
      if (this.$specialRuleProviderSlug.includes(this.$slug)) {
        this.$router.push('/lockers')
      } else {
        this.$router.push('/delivery')
      }
    },
  },
}
